<template>
  <v-container class="py-0 px-0">
    <v-card tile>
      <v-card-text class="py-0">
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-row>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <v-text-field
                  label="Kode TTB"
                  dense
                  small-chips
                  disabled
                  v-model="formData.kodettb"
                  ref="focusNoTTB"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <!-- <input type="text" v-model="formData.nottb"> -->
                <v-text-field
                  label="No TTB"
                  dense
                  small-chips
                  @blur="updateNoTTB"
                  :loading="loading.nottb"
                  v-model="formData.nottb"
                  hide-details
                  @keydown.enter="focusTgl"
                  ref="focusNoTTB"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <label for="tglttb">Tgl TTB</label>
                <input
                  type="date"
                  id="tglttb"
                  placeholder="Tanggal TTB"
                  v-model="formData.tgl"
                  class="w-100"
                  @blur="updateTgl"
                  @keydown.enter="focusPortAwal"
                  ref="focusTgl"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <v-combobox
                  label="Port Awal"
                  :items="items.portAwal"
                  :loading="loading.portAwal"
                  :disabled="loading.portAwal"
                  v-model="formData.port_awal"
                  dense
                  hide-details
                  @change="focusTujuanPengiriman"
                  @keydown.enter="focusTujuanPengiriman"
                  ref="focusPortAwal"
                >
                  <template #no-data>
                    <small class="ml-2"
                      ><a href="" @click.prevent="state.createPortAwal = true"
                        >Add New</a
                      ></small
                    >
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <v-combobox
                  label="Tujuan Pengiriman"
                  :items="items.tujuanPengiriman"
                  :loading="loading.tujuanPengiriman"
                  :disabled="loading.tujuanPengiriman"
                  v-model="formData.tujuan"
                  dense
                  hide-details
                  @change="focusKondisiPengiriman"
                  @keydown.enter="focusKondisiPengiriman"
                  ref="focusTujuanPengiriman"
                >
                  <template #no-data>
                    <small class="ml-2"
                      ><a
                        href=""
                        @click.prevent="state.createTujuanPengiriman = true"
                        >Add New</a
                      ></small
                    >
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <v-combobox
                  label="Kondisi Pengiriman"
                  :items="items.kondisiPengiriman"
                  :loading="loading.kondisiPengiriman"
                  :disabled="loading.kondisiPengiriman"
                  v-model="formData.kondisi"
                  dense
                  hide-details
                  @change="focusPenagihan"
                  @keydown.enter="focusPenagihan"
                  ref="focusKondisiPengiriman"
                >
                  <template #no-data>
                    <small class="ml-2"
                      ><a
                        href=""
                        @click.prevent="state.createKondisiPengiriman = true"
                        >Add New</a
                      ></small
                    >
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <v-autocomplete
                  :items="items.penagihan"
                  label="Penagihan"
                  dense
                  v-model="formData.penagihan"
                  hide-details
                  @change="focusMarketing"
                  @keydown.enter="focusMarketing"
                  ref="focusPenagihan"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <v-autocomplete
                  :items="items.kategori_barang"
                  label="Kategori Barang"
                  dense
                  v-model="formData.kategori_barang"
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <v-combobox
                  label="Marketing"
                  :items="items.marketing"
                  :loading="loading.marketing"
                  :disabled="loading.marketing"
                  dense
                  v-model="formData.marketing"
                  hide-details
                  @change="focusPenerimaBarang"
                  ref="focusMarketing"
                >
                  <template #no-data>
                    <small class="ml-2"
                      ><a href="" @click.prevent="state.createMarketing = true"
                        >Add New</a
                      ></small
                    >
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content py-1">
                <v-combobox
                  label="Penerima Barang"
                  :items="items.penerima_barang"
                  :loading="loading.penerima_barang"
                  :disabled="loading.penerima_barang"
                  dense
                  v-model="formData.penerima_barang"
                  hide-details
                  @change="focusKeteranganTambahan"
                  ref="focusPenerimaBarang"
                >
                  <template #no-data>
                    <small class="ml-2"
                      >Tidak ada data, silahkan tambahkan di menu kelola
                      karyawan</small
                    >
                  </template>
                  <!-- <template #no-data>
                    <small class="ml-2"
                      ><a
                        href=""
                        @click.prevent="state.createPenerimaTTB = true"
                        >Add New</a
                      ></small
                    >
                  </template> -->
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="py-2">
                <v-text-field
                  label="Keterangan Tambahan"
                  dense
                  small-chips
                  v-model="formData.ket"
                  @blur="updateKet"
                  hide-details
                  @keydown.enter="focusPengirim"
                  ref="focusKeteranganTambahan"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-combobox
                  label="Pengirim"
                  v-model="formData.pengirim"
                  :items="items.pengirim"
                  :loading="loading.pengirim"
                  item-text="nama_lengkap"
                  item-value="id"
                  dense
                  hide-details
                  @change="pengirimOnChange"
                  @keydown.enter="pengirimOnChange"
                  ref="focusPengirim"
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-row>
                  <v-col cols="12" sm="4" md="3">
                    <v-row class="height-full">
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-btn
                          depressed
                          color="primary"
                          class="height-full"
                          @click="state.createPengirim = true"
                          :disabled="formData.pengirim != ''"
                          :loading="loading.pengirim"
                        >
                          Add
                        </v-btn>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-btn
                          depressed
                          color="warning"
                          class="height-full"
                          @click="state.editPengirim = true"
                          :disabled="formData.pengirim == ''"
                          :loading="loading.pengirim"
                        >
                          Edit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="8" md="9">
                    <InfoPengirim :data="data.pengirim" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-combobox
                  label="Penerima"
                  v-model="formData.penerima"
                  :items="items.penerima"
                  :loading="loading.penerima"
                  item-text="nama_lengkap"
                  item-value="id"
                  @change="penerimaOnChange"
                  @keydown.enter="penerimaOnChange"
                  dense
                  hide-details
                  ref="focusPenerima"
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-row>
                  <v-col cols="12" sm="4" md="3">
                    <v-row class="height-full">
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-btn
                          depressed
                          color="primary"
                          class="height-full"
                          @click="state.createPenerima = true"
                          :disabled="formData.penerima != ''"
                          :loading="loading.penerima"
                        >
                          Add
                        </v-btn>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-btn
                          depressed
                          color="warning"
                          class="height-full"
                          @click="state.editPenerima = true"
                          :disabled="formData.penerima == ''"
                          :loading="loading.penerima"
                        >
                          Edit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="8" md="9">
                    <InfoPenerima :data="data.penerima" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <!-- <v-text-field
                  label="U/P Penerima"
                  dense
                  small-chips
                  hide-details
                  v-model="formData.up_penerima"
                  @blur="updateUpPenerima"
                  @keydown.enter="$refs.focusTgl.focus()"
                  ref="focusUPPenerima"
                ></v-text-field> -->
                <v-text-field
                  label="U/P Penerima"
                  dense
                  small-chips
                  hide-details
                  v-model="formData.up_penerima"
                  @blur="updateUpPenerima"
                  @keydown.enter="focusDetilKoli"
                  ref="focusUPPenerima"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="3" class="fit-content py-1">
                <label for="tglttb">Tgl TTB</label>
                <input
                  type="date"
                  id="tglttb"
                  placeholder="Tanggal TTB"
                  v-model="formData.tgl"
                  class="w-100"
                  @blur="updateTgl"
                  @keydown.enter="focusDetilKoli"
                  ref="focusTgl"
                />
              </v-col> -->
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="4" md="3" class="py-1">
                <v-checkbox
                  v-model="formData.ada_ba"
                  label="Berita Acara"
                  dense
                  hide-details
                  @change="toggleBeritaAcara"
                ></v-checkbox>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="3"
                class="py-1"
                v-if="formData.ada_ba"
              >
                <v-text-field
                  label="Tgl BA Kembali"
                  type="date"
                  dense
                  hide-details
                  v-model="formData.tgl_ba_kembali"
                  @blur="updateBeritaAcara"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="3"
                class="py-1"
                v-if="formData.ada_ba"
              >
                <v-text-field
                  label="Tgl Kirim BA"
                  type="date"
                  dense
                  hide-details
                  v-model="formData.tgl_kirim_ba"
                  @blur="updateBeritaAcara"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="3"
                class="py-1"
                v-if="formData.ada_ba"
              >
                <v-text-field
                  label="Keterangan BA"
                  dense
                  hide-details
                  v-model="formData.keterangan_ba"
                  @blur="updateBeritaAcara"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="12" md="12" class="py-0">
                <div class="mt-1">
                  <h4>Info Keberangkatan</h4>
                  <v-simple-table>
                    <thead>
                      <th>No Cont / KC</th>
                      <th>Koli Masuk</th>
                      <th>Tgl Stuffing</th>
                      <th>Nama Kapal</th>
                      <th>Tanggal Berangkat</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="infoKeberangkatan in data.infoKeberangkatan"
                        :key="infoKeberangkatan.id"
                      >
                        <td>
                          {{ infoKeberangkatan.container.no_container }} /
                          {{ infoKeberangkatan.container.kc }}
                        </td>
                        <td>
                          {{ infoKeberangkatan.koli_in || 0 }}
                        </td>
                        <td>
                          {{ formatTanggal(infoKeberangkatan.created_at) }}
                        </td>
                        <td v-if="infoKeberangkatan.vessel">
                          {{ infoKeberangkatan.vessel.vessel }}
                        </td>
                        <td v-else>-</td>
                        <td v-if="infoKeberangkatan.vessel">
                          {{
                            formatTanggal(
                              infoKeberangkatan.vessel.tgl_berangkat
                            )
                          }}
                        </td>
                        <td v-else>-</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-simple-table height="200px" fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Koli</th>
                    <th class="text-left">Packing</th>
                    <th class="text-left">Nama Barang</th>
                    <th class="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="12%" class="px-1">
                      <input
                        type="number"
                        class="input"
                        v-model="formDetilData.koli"
                        min="0"
                        @blur="tryAutoAddFormDetil"
                        @keydown.enter="focusDetilPacking"
                        ref="focusDetilKoli"
                      />
                    </td>
                    <td width="12%" class="px-1">
                      <input
                        type="text"
                        class="input"
                        v-model="formDetilData.packing"
                        @blur="tryAutoAddFormDetil"
                        @keydown.enter="focusDetilNamaBarang"
                        ref="focusDetilPacking"
                      />
                    </td>
                    <td width="70%" class="px-1">
                      <input
                        type="text"
                        class="input"
                        @blur="tryAutoAddFormDetil"
                        @keydown.enter="addFormDetil"
                        ref="focusDetilNamaBarang"
                        v-model="formDetilData.nama_barang"
                      />
                    </td>
                    <td width="6%" class="px-1">
                      <v-btn
                        depressed
                        color="primary"
                        :disabled="loading.addTtbDetil"
                        :loading="loading.addTtbDetil"
                        @click="addFormDetil"
                        class="v-btn-small"
                      >
                        Add
                      </v-btn>
                    </td>
                  </tr>

                  <FormDetilModal
                    v-for="ttbDetil in data.ttbDetils"
                    :key="ttbDetil.id"
                    :data="ttbDetil"
                    @update-koli="fetchTTBDetil"
                    @focus-main="focusRefs('focusDetilKoli')"
                  />
                </tbody>
              </template>
            </v-simple-table>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td width="12%" class="px-1">
                      <input
                        type="number"
                        class="input"
                        disabled
                        v-model="totalKoliTTBDetil"
                      />
                    </td>
                    <td width="12%" class="px-1">
                      <input
                        type="number"
                        class="input"
                        disabled
                        style="opacity: 0"
                      />
                    </td>
                    <td width="70%" class="px-1">
                      <input
                        type="number"
                        class="input"
                        disabled
                        style="opacity: 0"
                      />
                    </td>
                    <td width="6%" class="px-1">
                      <v-btn
                        depressed
                        color="primary"
                        class="v-btn-small"
                        disabled
                        style="opacity: 0"
                      ></v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table height="220px" fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Collie</th>
                    <th class="text-left">Packing</th>
                    <th class="text-center">P</th>
                    <th class="text-center">L</th>
                    <th class="text-center">T</th>
                    <th class="text-center">M3</th>
                    <th class="text-center">Kg</th>
                    <th class="text-center">Ton</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="px-1">
                      <input
                        type="number"
                        class="input"
                        v-model="formRinciData.koli"
                        @blur="tryAutoAddFormRinci"
                        @keydown.enter="focusRefs('formRinciPacking')"
                        ref="formRinciKoli"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="text"
                        class="input"
                        v-model="formRinciData.packing"
                        @blur="tryAutoAddFormRinci"
                        @keydown.enter="focusRefs('formRinciP')"
                        ref="formRinciPacking"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="number"
                        class="input"
                        v-model="formRinciData.p"
                        @blur="tryAutoAddFormRinci"
                        @keydown.enter="focusRefs('formRinciL')"
                        ref="formRinciP"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="number"
                        class="input"
                        v-model="formRinciData.l"
                        @blur="tryAutoAddFormRinci"
                        @keydown.enter="focusRefs('formRinciT')"
                        ref="formRinciL"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="number"
                        class="input"
                        v-model="formRinciData.t"
                        @blur="tryAutoAddFormRinci"
                        @keydown.enter="focusRefs('formRinciKG')"
                        ref="formRinciT"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="number"
                        class="input"
                        disabled
                        tabindex="-1"
                        v-model="calculateM3"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="number"
                        class="input"
                        v-model="formRinciData.kg"
                        ref="formRinciKG"
                        @blur="tryAutoAddFormRinci"
                        @keydown.enter="addFormRinci"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="number"
                        class="input"
                        disabled
                        tabindex="-1"
                        v-model="calculateTon"
                      />
                    </td>
                    <td class="px-1">
                      <v-btn
                        depressed
                        color="primary"
                        :disabled="loading.addTtbRinci"
                        :loading="loading.addTtbRinci"
                        @click="addFormRinci"
                        class="v-btn-small"
                      >
                        Add
                      </v-btn>
                    </td>
                  </tr>

                  <FormRinciModal
                    v-for="ttbrinci in data.ttbRincis"
                    :key="ttbrinci.id"
                    :data="ttbrinci"
                    @update-rinci="fetchTTBRinci"
                  />
                </tbody>
              </template>
            </v-simple-table>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="px-1">
                      <input
                        type="number"
                        class="input"
                        disabled
                        v-model="totalKoliTTBRinci"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="text"
                        class="input"
                        disabled
                        style="opacity: 0"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="text"
                        class="input"
                        disabled
                        style="opacity: 0"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="text"
                        class="input"
                        disabled
                        style="opacity: 0"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="text"
                        class="input"
                        disabled
                        style="opacity: 0"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="text"
                        class="input"
                        disabled
                        v-model="totalM3TTBRinci"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="text"
                        class="input"
                        disabled
                        style="opacity: 0"
                      />
                    </td>
                    <td class="px-1">
                      <input
                        type="text"
                        class="input"
                        disabled
                        v-model="totalTonTTBRinci"
                      />
                    </td>
                    <td class="px-1">
                      <v-btn
                        depressed
                        color="primary"
                        disabled
                        class="v-btn-small"
                        style="opacity: 0"
                      >
                        Save
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <p class="red--text" v-if="totalKoliTTBDetil != totalKoliTTBRinci">
              Jumlah Koli tidak sesuai
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Create Port Awal Modal -->
    <CreatePortAwal
      :openModal="state.createPortAwal"
      :tempData="formData.port_awal"
      @close-modal="
        state.createPortAwal = false;
        formData.port_awal = '';
        focusPortAwal();
      "
      @update-data="changePortAwal"
    />

    <!-- Create Tujuan Pengiriman Modal -->
    <CreateTujuanPengiriman
      :openModal="state.createTujuanPengiriman"
      :tempData="formData.tujuan"
      @close-modal="
        state.createTujuanPengiriman = false;
        formData.tujuan = '';
        $refs.focusTujuanPengiriman.$refs.input.click();
      "
      @update-data="changeTujuanPengiriman"
    />

    <!-- Create Kondisi Pengiriman Modal -->
    <CreateKondisiPengiriman
      :openModal="state.createKondisiPengiriman"
      :tempData="formData.kondisi"
      @close-modal="
        state.createKondisiPengiriman = false;
        formData.kondisi = '';
        $refs.focusKondisiPengiriman.$refs.input.click();
      "
      @update-data="changeKondisiPengiriman"
    />

    <!-- Create New Pengirim Modal -->
    <CreatePengirim
      :openModal="state.createPengirim"
      :tempData="formData.pengirim"
      :kota="formData.port_awal"
      @close-modal="
        state.createPengirim = false;
        formData.pengirim = '';
        $refs.focusPengirim.$refs.input.click();
      "
      @update-data="changePengirim"
    />

    <!-- Edit Pengirim Modal -->
    <EditPengirim
      :openModal="state.editPengirim"
      :data="data.pengirim"
      @close-modal="
        state.editPengirim = false;
        formData.pengirim = '';
        $refs.focusPengirim.$refs.input.click();
      "
      @update-data="updateChangePengirim"
    />

    <!-- Create New Penerima Modal -->
    <CreatePenerima
      :openModal="state.createPenerima"
      :tempData="formData.penerima"
      :kota="formData.tujuan"
      @close-modal="
        state.createPenerima = false;
        formData.penerima = '';
        $refs.focusPenerima.$refs.input.click();
      "
      @update-data="changePenerima"
    />

    <!-- Edit Penerima Modal -->
    <EditPenerima
      :openModal="state.editPenerima"
      :data="data.penerima"
      :ttb="formData.kodettb"
      @close-modal="
        state.editPenerima = false;
        formData.penerima = '';
        $refs.focusPenerima.$refs.input.click();
      "
      @update-data="updateChangePenerima"
    />

    <!-- Create Karyawan Modal -->
    <CreateMarketingModal
      :openModal="state.createMarketing"
      :tempData="formData.marketing"
      @close-modal="
        state.createMarketing = false;
        formData.marketing = '';
        $refs.focusMarketing.$refs.input.click();
      "
      @update-data="changeMarketing"
    />

    <!-- Create karyawan Modal -->
    <!-- <CreatePenerimaBarang
      :openModal="state.createPenerimaTTB"
      :tempData="formData.marketing"
      @close-modal="
        state.createPenerimaTTB = false;
        formData.marketing = '';
        $refs.focusPenerimaBarang.$refs.input.click();
      "
      @update-data="changePenerimaBarang"
    /> -->

    <!-- Modal Fetch Data TTB -->
    <FindKodeTTB :openModal="!haveNoTTB" @close-modal="fetchDataTTB" />

    <!-- Confirm Delete Modal -->
    <ConfirmDelete
      :openModal="state.confirmDelete"
      :loadingData="loading.deleteTTB"
      @cancel-delete="state.confirmDelete = false"
      @process-delete="deleteTTB"
    />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      ref="focusNewButton"
      :loading="loading.saveTTB"
      @click="saveTTB"
    >
      New
    </v-btn>

    <!-- Print Button -->
    <v-btn
      class="mx-2 btn-print"
      fab
      dark
      right
      bottom
      fixed
      color="info"
      @click="printTTB"
    >
      Print
    </v-btn>

    <!-- Delete Button -->
    <v-btn
      class="mx-2 btn-delete"
      fab
      dark
      right
      bottom
      fixed
      color="error"
      @click="state.confirmDelete = true"
      :loading="loading.deleteTTB"
    >
      Delete
    </v-btn>
  </v-container>
</template>

<script>
import axios from "axios";
import { sync } from "vuex-pathify";

export default {
  name: "TTBModal",
  components: {
    FindKodeTTB: () => import("@/components/TTB/TTBModal.vue"),
    ConfirmDelete: () => import("@/components/TTB/ConfirmDelete.vue"),
    CreateTujuanPengiriman: () =>
      import("@/components/TujuanPengiriman/CreateModal.vue"),
    CreatePortAwal: () => import("@/components/PortAwal/CreateModal.vue"),
    CreateKondisiPengiriman: () =>
      import("@/components/KondisiPengiriman/CreateModal.vue"),
    InfoPengirim: () => import("@/components/Pengirim/Info.vue"),
    InfoPenerima: () => import("@/components/Penerima/Info.vue"),
    CreatePengirim: () => import("@/components/Pengirim/CreateModal.vue"),
    EditPengirim: () => import("@/components/Pengirim/EditModal.vue"),
    CreatePenerima: () => import("@/components/Penerima/CreateModal.vue"),
    EditPenerima: () => import("@/components/Penerima/EditModal.vue"),
    FormDetilModal: () => import("@/components/TTBDetil/FormDetil.vue"),
    FormRinciModal: () => import("@/components/TTBRinci/FormRinci.vue"),
    CreateMarketingModal: () =>
      import("@/components/Marketing/CreateModal.vue"),
    CreatePenerimaBarang: () =>
      import("@/components/PenerimaTTB/CreateModal.vue")
  },
  data() {
    return {
      dataTTB: {},
      haveNoTTB: false,
      items: {
        penagihan: [
          {
            text: "1. Pengirim",
            value: "1. Pengirim"
          },
          {
            text: "2. Penerima",
            value: "2. Penerima"
          },
          {
            text: "3. Lunas",
            value: "3. Lunas"
          }
        ],
        kategori_barang: ["BERAT", "RINGAN"],
        marketing: [],
        penerima_barang: [],
        tujuanPengiriman: [],
        kondisiPengiriman: [],
        pengirim: [],
        kodettb: "",
        penerima: [],
        portAwal: []
      },
      formData: {
        // tgl: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        //   .toISOString()
        //   .substr(0, 10),
        tgl: "",
        nottb: "",
        port_awal: "",
        tujuan: "",
        kondisi: "",
        penagihan: "",
        kategori_barang: "",
        marketing: "",
        penerima_barang: "",
        ket: "",
        pengirim: "",
        penerima: "",
        up_penerima: "",
        ada_ba: false,
        tgl_ba_kembali: "",
        tgl_kirim_ba: "",
        keterangan_ba: ""
      },
      loading: {
        tujuanPengiriman: false,
        kondisiPengiriman: false,
        pengirim: false,
        penerima: false,
        nottb: false,
        ttbdetil: false,
        ttbrinci: false,
        addTtbDetil: false,
        addTtbRinci: false,
        portAwal: false,
        saveTTB: false,
        marketing: false,
        penerima_barang: false,
        deleteTTB: false
      },
      state: {
        createTujuanPengiriman: false,
        createKondisiPengiriman: false,
        createPengirim: false,
        createPenerima: false,
        createPortAwal: false,
        createMarketing: false,
        createPenerimaTTB: false,
        editPengirim: false,
        editPenerima: false,
        confirmDelete: false
      },
      data: {
        pengirim: {},
        penerima: {},
        ttbDetils: [],
        ttbRincis: [],
        infoKeberangkatan: []
      },
      formDetilData: {
        koli: "",
        packing: "",
        nama_barang: ""
      },
      formRinciData: {
        koli: "",
        packing: "",
        p: "",
        l: "",
        t: "",
        m3: "",
        kg: 0,
        ton: ""
      },
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
      autoSaveState: {
        detilKey: "",
        rinciKey: "",
        draftKey: ""
      }
    };
  },
  computed: {
    mini: sync("app/mini"),
    totalKoliTTBDetil() {
      return this.data.ttbDetils.reduce((a, b) => a + parseInt(b.koli || 0), 0);
    },
    totalKoliTTBRinci() {
      return this.data.ttbRincis.reduce((a, b) => a + parseInt(b.koli || 0), 0);
    },
    totalM3TTBRinci() {
      return this.data.ttbRincis.reduce((a, b) => a + b.m3, 0).toFixed(2);
    },
    totalTonTTBRinci() {
      return this.data.ttbRincis.reduce((a, b) => a + b.ton, 0).toFixed(2);
    },
    calculateM3: {
      get: function() {
        const value = (
          Math.round(
            ((this.formRinciData.p *
              this.formRinciData.l *
              this.formRinciData.t) /
              1000000) *
              this.formRinciData.koli *
              100
          ) / 100
        ).toFixed(2);
        this.formRinciData.m3 = value;

        return value;
      },
      set: function(value) {
        this.formRinciData.m3 = value;
      }
    },
    calculateTon: {
      get: function() {
        return (
          (this.formRinciData.kg * this.formRinciData.koli) /
          1000
        ).toFixed(2);
      },
      set: function(value) {
        this.formRinciData.ton = value;
      }
    }
  },
  watch: {
    calculateTon(val) {
      this.formRinciData.ton = val;
    },
    // "formData.nottb"(val) {
    // if (val.length == 1) {
    //   // console.log(/^\d+$/.test(val.charAt(1)));
    //   if (/^\d+$/.test(val.charAt(1))) {
    //     // console.log('asdf')
    //     this.formData = val.substring(0, val.length - 1);
    //   }
    // }
    // this.formData.nottb = val;
    // this.formData.nottb = val.replace(/^[^\d]*(\d+)/, '');
    // },
    "formData.nottb"(val) {
      if (val) {
        this.formData.nottb = val.toUpperCase();
      }
    },
    "formData.tujuan"(val) {
      if (val) {
        this.fetchPenerima();
        this.updateTujuan();
      }
    },
    "formData.port_awal"(val) {
      if (val) {
        this.fetchPengirim();
        this.updatePortAwal();
      }
    },
    "formData.kondisi"(val) {
      if (val) {
        this.updateKondisi();
      }
    },
    "formData.penagihan"(val) {
      if (val) {
        this.updatePenagihan();
      }
    },
    "formData.kategori_barang"(val) {
      if (val) {
        this.updateKategoriBarang();
      }
    },
    "formData.marketing"(val) {
      if (val) {
        this.updateMarketing();
      }
    },
    "formData.penerima_barang"(val) {
      if (val) {
        this.updatePenerimaBarang();
      }
    },
    "formData.pengirim"(val) {
      if (val) {
        this.updatePengirim();
      }
    },
    "formData.penerima"(val) {
      if (val) {
        this.updatePenerima();
      }
    },
    dataTTB(val) {
      this.formData.kodettb = val.kodettb;
      this.formData.nottb = val.nottb;

      this.updatePortAwal();

      this.$nextTick(() => {
        this.focusNoTTB();
        // this.$refs.focusTgl.focus();
      });

      if (val.tgl) {
        this.formData.tgl = val.tgl;
      }

      if (val.penagihan) {
        this.formData.penagihan = val.penagihan;
      }

      if (val.kategori_barang) {
        this.formData.kategori_barang = val.kategori_barang;
      }

      if (val.ket) {
        this.formData.ket = val.ket;
      }

      if (val.up_penerima) {
        this.formData.up_penerima = val.up_penerima;
      }

      if (val.pengirim_detil) {
        this.formData.pengirim = val.pengirim_detil;
        this.data.pengirim = val.pengirim_detil;
      }

      if (val.penerima_detil) {
        this.formData.penerima = val.penerima_detil;
        this.data.penerima = val.penerima_detil;
      }

      if (val.kondisi_detil) {
        this.formData.kondisi = {
          text: `${val.kondisi_detil.kondisi}`,
          value: val.kondisi_detil.id
        };
      }

      if (val.tujuan_detil) {
        this.formData.tujuan = {
          text: val.tujuan_detil.kota,
          value: val.tujuan_detil.id
        };
      }

      if (val.port_awal_detil) {
        this.formData.port_awal = {
          text: val.port_awal_detil.kota,
          value: val.port_awal_detil.id
        };
      }

      if (val.marketing_detil) {
        this.formData.marketing = {
          text: val.marketing_detil.nama,
          value: val.marketing_detil.user_id
        };
      }

      if (val.penerima_barang_detil) {
        this.formData.penerima_barang = {
          text: val.penerima_barang_detil.nama,
          value: val.penerima_barang_detil.user_id
        };
      }

      if (val.ttb_detil) {
        this.data.ttbDetils = val.ttb_detil;
      }

      if (val.ttb_rinci) {
        this.data.ttbRincis = val.ttb_rinci;
      }

      if (val.info_keberangkatan) {
        this.data.infoKeberangkatan = val.info_keberangkatan;
      }

      this.fetchBeritaAcara();
    }
  },
  methods: {
    isTujuanSelected() {
      return !!(
        this.formData.tujuan &&
        typeof this.formData.tujuan === "object" &&
        this.formData.tujuan.value
      );
    },
    hasAnyKoli() {
      return (
        this.totalKoliTTBDetil > 0 ||
        this.totalKoliTTBRinci > 0 ||
        Number(this.formDetilData.koli || 0) > 0 ||
        Number(this.formRinciData.koli || 0) > 0
      );
    },
    canAutoSaveTTB() {
      return !!(
        this.formData.kodettb &&
        this.isTujuanSelected() &&
        this.hasAnyKoli()
      );
    },
    skipAutoSaveIfInvalid(showAlert = false) {
      if (this.formData.kodettb) return false;

      if (showAlert) {
        alert("Kode TTB belum tersedia.");
      }

      return true;
    },
    printTTB() {
      window.open(
        `${window.location.origin}/printTTB.html?id=${this.formData.kodettb}`
      );
    },
    async saveTTB() {
      if (!this.formData.tgl) {
        alert("Tanggal TTB tidak boleh kosong");

        return;
      }

      if (this.totalKoliTTBDetil != this.totalKoliTTBRinci) {
        this.loading.saveTTB = true;

        await axios
          .put(`update-ttb/koli-tidak-sesuai?kodettb=${this.formData.kodettb}`)
          .then(res => {
            this.loading.saveTTB = false;
            this.resetForm();
          })
          .catch(err => {
            this.loading.saveTTB = false;
            alert(err.response.data.message);
          });
      } else {
        this.resetForm();
      }
    },
    async deleteTTB() {
      this.loading.deleteTTB = true;

      await axios
        .delete(`ttb/${this.formData.kodettb}`)
        .then(res => {
          this.loading.deleteTTB = false;
          this.state.confirmDelete = false;

          this.resetForm();
        })
        .catch(err => {
          this.loading.deleteTTB = false;
          this.state.confirmDelete = false;

          alert(err.response.data.message);
        });
    },
    fetchDataTTB(val) {
      this.haveNoTTB = true;
      this.mini = true;

      this.dataTTB = val;
    },
    async fetchMarketing() {
      await axios
        .get(`marketing`)
        .then(res => {
          this.items.marketing = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchPenerimaBarang() {
      await axios
        .get(`penerima-barang`)
        .then(res => {
          this.items.penerima_barang = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchPortAwal() {
      await axios
        .get(`port-awal`)
        .then(res => {
          this.items.portAwal = res.data.map(item => ({
            text: item.kota,
            value: item.id
          }));
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchTujuanPengiriman() {
      await axios
        .get(`tujuan-pengiriman`)
        .then(res => {
          this.items.tujuanPengiriman = res.data.map(item => ({
            text: item.kota,
            value: item.id
          }));
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchKondisiPengiriman() {
      await axios
        .get(`kondisi-pengiriman`)
        .then(res => {
          this.items.kondisiPengiriman = res.data.map(item => ({
            text: `${item.kondisi}`,
            value: item.id
          }));
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchPengirim() {
      await axios
        .get(`pengirim?kota=${this.formData.port_awal.text}`)
        .then(res => {
          this.items.pengirim = res.data;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchPenerima() {
      await axios
        .get(`penerima?kota=${this.formData.tujuan.text}`)
        .then(res => {
          this.items.penerima = res.data;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchKodeTTB() {
      // this.loading.nottb = true;

      await axios
        .get(`kodettb`)
        .then(res => {
          // this.loading.nottb = false;
          // // console.log(res.data);

          this.formData.kodettb = res.data.kodettb;
        })
        .catch(err => {
          // this.loading.nottb = false;

          alert(err.response.data.message);
        });
    },
    async fetchTTBDetil() {
      this.loading.ttbdetil = true;

      await axios
        .get(`ttb-detil?kodettb=${this.formData.kodettb}`)
        .then(res => {
          this.loading.ttbdetil = false;

          this.data.ttbDetils = res.data;
        })
        .catch(err => {
          this.loading.ttbdetil = false;

          alert(err.response.data.message);
        });
    },
    async fetchTTBRinci() {
      this.loading.ttbrinci = true;

      await axios
        .get(`ttb-rinci?kodettb=${this.formData.kodettb}`)
        .then(res => {
          this.loading.ttbrinci = false;

          this.data.ttbRincis = res.data;
        })
        .catch(err => {
          this.loading.ttbrinci = false;

          alert(err.response.data.message);
        });
    },
    async changePortAwal(item) {
      this.loading.portAwal = true;
      this.state.createPortAwal = false;

      await this.fetchPortAwal();

      this.formData.port_awal = {
        text: item.kota,
        value: item.id
      };

      this.loading.portAwal = false;
      this.focusTujuanPengiriman();
    },
    async changeTujuanPengiriman(item) {
      this.loading.tujuanPengiriman = true;
      this.state.createTujuanPengiriman = false;

      await this.fetchTujuanPengiriman();

      this.formData.tujuan = {
        text: item.kota,
        value: item.id
      };

      this.loading.tujuanPengiriman = false;
      this.focusKondisiPengiriman();
    },
    async changeKondisiPengiriman(item) {
      this.loading.kondisiPengiriman = true;
      this.state.createKondisiPengiriman = false;

      await this.fetchKondisiPengiriman();

      this.formData.kondisi = {
        text: `${item.kondisi}` + ` - ${item.ket}`,
        value: item.id
      };

      this.loading.kondisiPengiriman = false;
      this.focusPenagihan();
    },
    async changePengirim(item) {
      this.loading.pengirim = true;
      this.state.createPengirim = false;

      await this.fetchPengirim();

      this.data.pengirim = item;
      this.formData.pengirim = item;
      this.loading.pengirim = false;

      this.focusPenerima();
    },
    updateChangePengirim(item) {
      this.state.editPengirim = false;
      this.data.pengirim = item;
      this.formData.pengirim = item;

      this.focusPenerima();
    },
    async changePenerima(item) {
      this.loading.penerima = true;
      this.state.createPenerima = false;

      await this.fetchPenerima();

      this.data.penerima = item;
      this.formData.penerima = item;
      this.loading.penerima = false;

      this.focusUPPenerima();
    },
    updateChangePenerima(item) {
      this.state.editPenerima = false;
      this.data.penerima = item;
      this.formData.penerima = item;

      this.focusUPPenerima();
    },
    async changeMarketing(item) {
      this.loading.marketing = true;
      this.state.createMarketing = false;

      await this.fetchMarketing();

      this.formData.marketing = {
        text: item.nama,
        value: item.user_id
      };
      this.loading.marketing = false;

      this.focusKeteranganTambahan();
    },
    async changePenerimaBarang(item) {
      this.loading.marketing = true;
      this.state.createMarketing = false;

      await this.fetchMarketing();

      this.formData.marketing = {
        text: item.nama,
        value: item.user_id
      };
      this.loading.marketing = false;

      this.focusKeteranganTambahan();
    },
    async updateTgl() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/tgl`, {
          kodettb: this.formData.kodettb,
          tgl: this.formData.tgl
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Tanggal");
        });
    },
    async updateNoTTB() {
      if (this.skipAutoSaveIfInvalid()) return;

      this.loading.nottb = true;

      await axios
        .put(`update-ttb/nottb`, {
          kodettb: this.formData.kodettb,
          nottb: this.formData.nottb
        })
        .then(res => {
          this.loading.nottb = false;
        })
        .catch(err => {
          this.loading.nottb = false;

          alert(err.response.data.message);
        });
    },
    async updateTujuan() {
      if (
        !this.formData.tujuan ||
        typeof this.formData.tujuan !== "object" ||
        !this.formData.tujuan.value
      ) {
        return;
      }

      const portAwalValue =
        this.formData.port_awal &&
        typeof this.formData.port_awal === "object" &&
        this.formData.port_awal.value
          ? this.formData.port_awal.value
          : null;

      await axios
        .put(`update-ttb/tujuan`, {
          kodettb: this.formData.kodettb,
          tujuan: this.formData.tujuan.value,
          port_awal: portAwalValue
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Tujuan");
        });
    },
    async updatePortAwal() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/port-awal`, {
          kodettb: this.formData.kodettb,
          port_awal: this.formData.port_awal.value
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Port Awal");
        });
    },
    async updateKondisi() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/kondisi`, {
          kodettb: this.formData.kodettb,
          kondisi: this.formData.kondisi.value
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Kondisi");
        });
    },
    async updatePenagihan() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/penagihan`, {
          kodettb: this.formData.kodettb,
          penagihan: this.formData.penagihan
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Penagihan");
        });
    },
    async updateKategoriBarang() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/kategori-barang`, {
          kodettb: this.formData.kodettb,
          kategori_barang: this.formData.kategori_barang
        })
        .catch(() => {
          alert("Gagal Mengupdate Kategori Barang");
        });
    },
    async updateMarketing() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/marketing`, {
          kodettb: this.formData.kodettb,
          marketing: this.formData.marketing.value
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Marketing");
        });
    },
    async updatePenerimaBarang() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/penerima-barang`, {
          kodettb: this.formData.kodettb,
          penerima_barang: this.formData.penerima_barang.value
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Penerima Barang");
        });
    },
    async updateKet() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/ket`, {
          kodettb: this.formData.kodettb,
          ket: this.formData.ket
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Keterangan");
        });
    },
    async updatePengirim() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/pengirim`, {
          kodettb: this.formData.kodettb,
          pengirim: this.formData.pengirim.id
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Pengirim");
        });
    },
    async updatePenerima() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/penerima`, {
          kodettb: this.formData.kodettb,
          penerima: this.formData.penerima.id
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Penerima");
        });
    },
    async updateUpPenerima() {
      if (this.skipAutoSaveIfInvalid()) return;

      await axios
        .put(`update-ttb/up_penerima`, {
          kodettb: this.formData.kodettb,
          up_penerima: this.formData.up_penerima
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Up Penerima");
        });
    },
    async addFormDetil() {
      if (!this.isTujuanSelected()) {
        alert("Tujuan pengiriman wajib dipilih sebelum menyimpan data.");
        return;
      }

      if (Number(this.formDetilData.koli || 0) <= 0) {
        alert("Koli harus diisi lebih dari 0.");
        return;
      }

      this.loading.addTtbDetil = true;

      await axios
        .post(`ttb-detil?kodettb=${this.formData.kodettb}`, this.formDetilData)
        .then(async res => {
          this.loading.addTtbDetil = false;

          await this.syncTTBHeaderIfNeeded();

          this.formatTTBDetilForm();
          this.fetchTTBDetil();

          this.focusRefs("focusDetilKoli");
        })
        .catch(err => {
          this.loading.addTtbDetil = false;
          alert(err.response.data.message);
        });
    },
    buildDetilAutoSaveKey() {
      return [
        this.formData.kodettb,
        this.formDetilData.koli,
        this.formDetilData.packing,
        this.formDetilData.nama_barang
      ]
        .map(val => (val || "").toString().trim())
        .join("|");
    },
    async tryAutoAddFormDetil() {
      if (this.loading.addTtbDetil) return;
      if (Number(this.formDetilData.koli || 0) <= 0) return;

      await this.reserveTTBDraftFromKoli();

      if (!this.isTujuanSelected()) return;
      if (!this.formDetilData.packing || !this.formDetilData.nama_barang)
        return;

      const key = this.buildDetilAutoSaveKey();
      if (!key || this.autoSaveState.detilKey === key) return;

      this.autoSaveState.detilKey = key;

      try {
        await this.addFormDetil();
      } catch (error) {
        this.autoSaveState.detilKey = "";
      }
    },
    async addFormRinci() {
      if (!this.isTujuanSelected()) {
        alert("Tujuan pengiriman wajib dipilih sebelum menyimpan data.");
        return;
      }

      if (Number(this.formRinciData.koli || 0) <= 0) {
        alert("Koli harus diisi lebih dari 0.");
        return;
      }

      this.loading.addTtbRinci = true;

      await axios
        .post(`ttb-rinci?kodettb=${this.formData.kodettb}`, this.formRinciData)
        .then(async res => {
          this.loading.addTtbRinci = false;

          await this.syncTTBHeaderIfNeeded();

          this.formatTTBRinciForm();
          this.fetchTTBRinci();

          this.focusRefs("formRinciKoli");
        })
        .catch(err => {
          this.loading.addTtbRinci = false;

          alert(err.response.data.message);
        });
    },
    buildRinciAutoSaveKey() {
      return [
        this.formData.kodettb,
        this.formRinciData.koli,
        this.formRinciData.packing,
        this.formRinciData.p,
        this.formRinciData.l,
        this.formRinciData.t,
        this.formRinciData.kg
      ]
        .map(val => (val || "").toString().trim())
        .join("|");
    },
    async tryAutoAddFormRinci() {
      if (this.loading.addTtbRinci) return;
      if (Number(this.formRinciData.koli || 0) <= 0) return;

      await this.reserveTTBDraftFromKoli();

      if (!this.isTujuanSelected()) return;
      if (!this.formRinciData.packing) return;
      if (Number(this.formRinciData.p || 0) <= 0) return;
      if (Number(this.formRinciData.l || 0) <= 0) return;
      if (Number(this.formRinciData.t || 0) <= 0) return;
      if (Number(this.formRinciData.kg || 0) <= 0) return;

      const key = this.buildRinciAutoSaveKey();
      if (!key || this.autoSaveState.rinciKey === key) return;

      this.autoSaveState.rinciKey = key;

      try {
        await this.addFormRinci();
      } catch (error) {
        this.autoSaveState.rinciKey = "";
      }
    },
    async reserveTTBDraftFromKoli() {
      if (!this.formData.kodettb) return;

      const totalKoliInput =
        Number(this.formDetilData.koli || 0) +
        Number(this.formRinciData.koli || 0);

      if (totalKoliInput <= 0) return;

      const draftKey = `${this.formData.kodettb}|${totalKoliInput}`;
      if (this.autoSaveState.draftKey === draftKey) return;

      this.autoSaveState.draftKey = draftKey;

      const portAwalValue =
        this.formData.port_awal &&
        typeof this.formData.port_awal === "object" &&
        this.formData.port_awal.value
          ? this.formData.port_awal.value
          : null;

      try {
        await axios.put(`update-ttb/reserve`, {
          kodettb: this.formData.kodettb,
          port_awal: portAwalValue
        });
      } catch (error) {
        this.autoSaveState.draftKey = "";
      }
    },
    formatTTBDetilForm() {
      this.formDetilData = {
        koli: "",
        packing: "",
        nama_barang: ""
      };

      this.autoSaveState.detilKey = "";
      this.autoSaveState.draftKey = "";
    },
    async syncTTBHeaderIfNeeded() {
      if (!this.formData.kodettb) return;

      const requests = [];

      if (this.formData.tgl) {
        requests.push(
          axios.put(`update-ttb/tgl`, {
            kodettb: this.formData.kodettb,
            tgl: this.formData.tgl
          })
        );
      }

      if (this.formData.nottb) {
        requests.push(
          axios.put(`update-ttb/nottb`, {
            kodettb: this.formData.kodettb,
            nottb: this.formData.nottb
          })
        );
      }

      if (
        this.formData.port_awal &&
        typeof this.formData.port_awal === "object" &&
        this.formData.port_awal.value
      ) {
        requests.push(
          axios.put(`update-ttb/port-awal`, {
            kodettb: this.formData.kodettb,
            port_awal: this.formData.port_awal.value
          })
        );
      }

      if (
        this.formData.tujuan &&
        typeof this.formData.tujuan === "object" &&
        this.formData.tujuan.value
      ) {
        requests.push(
          axios.put(`update-ttb/tujuan`, {
            kodettb: this.formData.kodettb,
            tujuan: this.formData.tujuan.value
          })
        );
      }

      if (
        this.formData.kondisi &&
        typeof this.formData.kondisi === "object" &&
        this.formData.kondisi.value
      ) {
        requests.push(
          axios.put(`update-ttb/kondisi`, {
            kodettb: this.formData.kodettb,
            kondisi: this.formData.kondisi.value
          })
        );
      }

      if (this.formData.penagihan) {
        requests.push(
          axios.put(`update-ttb/penagihan`, {
            kodettb: this.formData.kodettb,
            penagihan: this.formData.penagihan
          })
        );
      }

      if (this.formData.kategori_barang) {
        requests.push(
          axios.put(`update-ttb/kategori-barang`, {
            kodettb: this.formData.kodettb,
            kategori_barang: this.formData.kategori_barang
          })
        );
      }

      if (
        this.formData.marketing &&
        typeof this.formData.marketing === "object" &&
        this.formData.marketing.value
      ) {
        requests.push(
          axios.put(`update-ttb/marketing`, {
            kodettb: this.formData.kodettb,
            marketing: this.formData.marketing.value
          })
        );
      }

      if (
        this.formData.penerima_barang &&
        typeof this.formData.penerima_barang === "object" &&
        this.formData.penerima_barang.value
      ) {
        requests.push(
          axios.put(`update-ttb/penerima-barang`, {
            kodettb: this.formData.kodettb,
            penerima_barang: this.formData.penerima_barang.value
          })
        );
      }

      if (this.formData.ket) {
        requests.push(
          axios.put(`update-ttb/ket`, {
            kodettb: this.formData.kodettb,
            ket: this.formData.ket
          })
        );
      }

      if (
        this.formData.pengirim &&
        typeof this.formData.pengirim === "object" &&
        this.formData.pengirim.id
      ) {
        requests.push(
          axios.put(`update-ttb/pengirim`, {
            kodettb: this.formData.kodettb,
            pengirim: this.formData.pengirim.id
          })
        );
      }

      if (
        this.formData.penerima &&
        typeof this.formData.penerima === "object" &&
        this.formData.penerima.id
      ) {
        requests.push(
          axios.put(`update-ttb/penerima`, {
            kodettb: this.formData.kodettb,
            penerima: this.formData.penerima.id
          })
        );
      }

      if (this.formData.up_penerima) {
        requests.push(
          axios.put(`update-ttb/up_penerima`, {
            kodettb: this.formData.kodettb,
            up_penerima: this.formData.up_penerima
          })
        );
      }

      if (!requests.length) return;

      await Promise.all(requests.map(request => request.catch(() => null)));
    },
    formatTTBRinciForm() {
      this.formRinciData = {
        koli: "",
        packing: "",
        p: "",
        l: "",
        t: "",
        m3: "",
        kg: 0,
        ton: ""
      };

      this.autoSaveState.rinciKey = "";
      this.autoSaveState.draftKey = "";
    },
    resetForm() {
      const portAwal = this.formData.port_awal;

      this.formData = {
        kodettb: "",
        nottb: "",
        port_awal: portAwal,
        tujuan: "",
        kondisi: "",
        penagihan: "",
        kategori_barang: "",
        marketing: "",
        ket: "",
        pengirim: "",
        penerima: "",
        up_penerima: "",
        ada_ba: false,
        tgl_ba_kembali: "",
        tgl_kirim_ba: "",
        keterangan_ba: ""
      };

      this.data = {
        pengirim: {},
        penerima: {},
        ttbDetils: [],
        ttbRincis: []
      };

      this.haveNoTTB = false;
    },
    pengirimOnChange() {
      this.focusPenerima();

      if (this.formData.pengirim) {
        this.data.pengirim = this.formData.pengirim;
      }
    },
    penerimaOnChange() {
      this.focusUPPenerima();

      if (this.formData.penerima) {
        this.data.penerima = this.formData.penerima;
      }
    },
    focusNoTTB() {
      setTimeout(() => {
        this.$refs.focusNoTTB.$refs.input.click();
      }, 1);
    },
    focusTgl() {
      setTimeout(() => {
        if (this.formData.nottb && this.$refs.focusTgl) {
          this.$refs.focusTgl.focus();
        }
      }, 1);
    },
    focusPortAwal() {
      setTimeout(() => {
        if (this.formData.nottb) {
          this.$refs.focusPortAwal.$refs.input.click();
        }
      }, 1);
    },
    focusTujuanPengiriman() {
      setTimeout(() => {
        if (
          this.formData.port_awal != "" &&
          typeof this.formData.port_awal !== "object"
        ) {
          if (
            !this.items.portAwal.some(arr =>
              arr.text.match(new RegExp(this.formData.port_awal, "i"))
            )
          ) {
            this.state.createPortAwal = true;
          }
        } else {
          if (
            this.formData.port_awal &&
            typeof this.formData.port_awal === "object"
          ) {
            this.$refs.focusTujuanPengiriman.$refs.input.click();
          }
        }
      }, 1);
    },
    focusKondisiPengiriman() {
      setTimeout(() => {
        if (
          this.formData.tujuan != "" &&
          typeof this.formData.tujuan !== "object"
        ) {
          if (
            !this.items.tujuanPengiriman.some(arr =>
              arr.text.match(new RegExp(this.formData.tujuan, "i"))
            )
          ) {
            this.state.createTujuanPengiriman = true;
          }
        } else {
          if (
            this.formData.tujuan &&
            typeof this.formData.tujuan === "object"
          ) {
            this.$refs.focusKondisiPengiriman.$refs.input.click();
          }
        }
      }, 1);
    },
    focusPenagihan() {
      setTimeout(() => {
        if (
          this.formData.kondisi != "" &&
          typeof this.formData.kondisi !== "object"
        ) {
          if (
            !this.items.kondisiPengiriman.some(arr =>
              arr.text.match(new RegExp(this.formData.kondisi, "i"))
            )
          ) {
            this.state.createKondisiPengiriman = true;
          }
        } else {
          if (
            this.formData.kondisi &&
            typeof this.formData.kondisi === "object"
          ) {
            this.$refs.focusPenagihan.$refs.input.click();
          }
        }
      }, 1);
    },
    focusMarketing() {
      setTimeout(() => {
        if (this.formData.penagihan) {
          this.$refs.focusMarketing.$refs.input.click();
        }
      }, 1);
    },
    focusPenerimaBarang() {
      setTimeout(() => {
        if (this.formData.marketing) {
          this.$refs.focusPenerimaBarang.$refs.input.click();
        }
      }, 1);
    },
    focusKeteranganTambahan() {
      setTimeout(() => {
        if (
          this.formData.marketing != "" &&
          typeof this.formData.marketing !== "object"
        ) {
          if (
            !this.items.marketing.some(arr =>
              arr.text.match(new RegExp(this.formData.marketing, "i"))
            )
          ) {
            this.state.createMarketing = true;
          }
        } else {
          if (
            this.formData.marketing &&
            typeof this.formData.marketing === "object"
          ) {
            this.$refs.focusKeteranganTambahan.$refs.input.click();
          }
        }
      }, 1);
    },
    focusPengirim() {
      setTimeout(() => {
        if (this.formData.ket) {
          this.$refs.focusPengirim.$refs.input.click();
        }
      }, 1);
    },
    focusPenerima() {
      setTimeout(() => {
        if (
          this.formData.pengirim != "" &&
          typeof this.formData.pengirim !== "object"
        ) {
          if (
            !this.items.pengirim.some(arr =>
              arr.nama_lengkap.match(new RegExp(this.formData.pengirim, "i"))
            )
          ) {
            this.state.createPengirim = true;
          }
        } else {
          if (
            this.formData.pengirim &&
            typeof this.formData.pengirim === "object"
          ) {
            this.$refs.focusPenerima.$refs.input.click();
          }
        }
      }, 1);
    },
    focusUPPenerima() {
      setTimeout(() => {
        if (
          this.formData.penerima != "" &&
          typeof this.formData.penerima !== "object"
        ) {
          if (
            !this.items.penerima.some(arr =>
              arr.nama_lengkap.match(new RegExp(this.formData.penerima, "i"))
            )
          ) {
            this.state.createPenerima = true;
          }
        } else {
          if (
            this.formData.penerima &&
            typeof this.formData.penerima === "object"
          ) {
            this.$refs.focusUPPenerima.$refs.input.click();
          }
        }
      }, 1);
    },
    focusDetilKoli() {
      setTimeout(() => {
        if (this.formData.up_penerima) {
          this.$refs.focusDetilKoli.focus();
        }
      }, 1);
    },
    focusDetilPacking() {
      setTimeout(() => {
        this.$refs.focusDetilPacking.focus();
      }, 1);
    },
    focusDetilNamaBarang() {
      setTimeout(() => {
        this.$refs.focusDetilNamaBarang.focus();
      }, 1);
    },
    focusNewButton() {
      setTimeout(() => {
        this.$refs.focusNewButton.$el.focus();
      }, 1);
    },
    focusRefs(id) {
      this.$refs[id].focus();
    },
    async toggleBeritaAcara() {
      if (!this.formData.kodettb) return;
      await axios
        .put(`berita-acara/toggle/${this.formData.kodettb}`)
        .then(() => {})
        .catch(err => {
          alert(err.response?.data?.message || "Gagal toggle BA");
        });
    },
    async updateBeritaAcara() {
      if (!this.formData.kodettb) return;
      await axios
        .post(`berita-acara/update-kembali`, {
          kodettb: this.formData.kodettb,
          tgl_ba_kembali: this.formData.tgl_ba_kembali,
          keterangan_ba: this.formData.keterangan_ba
        })
        .then(() => {})
        .catch(err => {
          alert(err.response?.data?.message || "Gagal update BA");
        });
    },
    async fetchBeritaAcara() {
      if (!this.formData.kodettb) return;
      await axios
        .get(`berita-acara?kodettb=${this.formData.kodettb}`)
        .then(res => {
          if (res.data && res.data.length > 0) {
            const ba = res.data[0];
            this.formData.ada_ba = !!ba.ada_ba;
            this.formData.tgl_ba_kembali = ba.tgl_ba_kembali || "";
            this.formData.tgl_kirim_ba = ba.tgl_kirim_ba || "";
            this.formData.keterangan_ba = ba.keterangan_ba || "";
          }
        })
        .catch(() => {});
    },
    formatTanggal(data) {
      let date = new Date(data);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    }
  },
  async created() {
    await this.fetchMarketing();
    await this.fetchPenerimaBarang();
    await this.fetchTujuanPengiriman();
    await this.fetchPortAwal();
    await this.fetchKondisiPengiriman();
    // await this.fetchPengirim();
    // await this.fetchPenerima();

    if (localStorage.getItem("port_awal")) {
      this.formData.port_awal = JSON.parse(localStorage.getItem("port_awal"));
    }
  }
};
</script>

<style scoped>
.toolbar {
  max-height: 64px;
}

.p-0 {
  padding: 0 !important;
}

.w-100 {
  width: 100%;
}

.color-black {
  color: #000000 !important;
}

.height-full {
  height: 100% !important;
}

.fit-content {
  height: fit-content;
}

.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.v-btn-small {
  height: 25px !important;
}

.btn-print {
  bottom: 80px;
}

.btn-delete {
  bottom: 145px;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}
</style>

<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
